import {
  call,
  put,
  takeLatest,
} from 'redux-saga/effects';

import {
  ERROR_PASS_REQUEST,
  ERROR_UPDATE_REQUEST,
} from '@/action-types/error';

import api from '@/api/payment';
import { Action } from 'redux';
import { PAYMENT_REQUEST_ADMIN, PAYMENT_SUCCESS_ADMIN } from '@/action-types/admin';

export function* paymentRequest(params: {
  priceId: number;
}) {
  try {
    if (params.priceId) {
      const paymentResponse = yield call(api.makePayment, params.priceId);
      const continuePaymentResponse = yield call(
        api.continuePayment,
        paymentResponse.data.makePayment.id,
      );

      if (continuePaymentResponse.data.continuePayment.orderUrl) {
        const win = window.open('', '_blank');

        if (win && win.document) {
          win.document.write('Loading preview...');
          win.location.href = continuePaymentResponse.data.continuePayment.orderUrl;
        }

        yield put({ type: PAYMENT_SUCCESS_ADMIN });
      } else {
        yield put({ type: ERROR_UPDATE_REQUEST, isActive: true, errorData: { errorText: 'Can\'t process your request.' } });
      }
    }
  } catch (e) {
    yield put({ type: ERROR_PASS_REQUEST, error: e, tags: ['logic', 'paymentRequest'] });
    yield put({ type: ERROR_UPDATE_REQUEST, isActive: true, errorData: e });
  }
}

export default function* payment() {
  yield takeLatest<Action & {priceId: number;}>(PAYMENT_REQUEST_ADMIN, paymentRequest);
}
